(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('gameTrackerChartFactory', gameTrackerChartFactory);

    gameTrackerChartFactory.$inject = ['$filter', 'summaryItemType'];
    function gameTrackerChartFactory($filter, summaryItemType) {
        var percentageFilter = $filter('percentage');

        return function gameTrackerChartFactory(data) {
            var result = data.reduce(reduce, { data: [], colors: [], labels: [] });
            result.options = { tooltips: { callbacks: { label: getLabel } } };
            return result;

            ////////////////////////////////////////

            function reduce(acc, item) {
                var metadata = summaryItemType.$metadata[item.type];
                acc.data.push(item.value);
                acc.colors.push(metadata.color);
                acc.labels.push(metadata.displayName);
                return acc;
            }
            function getLabel(tooltipItem, $data) {
                var label = $data.labels[tooltipItem.index],
                     item = data[tooltipItem.index];
                return "{0}: {1} ({2})".format(label, item.value, percentageFilter(item.percent, 1));
            }
        }
    }
})();
